import { Modal } from 'components/Modal';
import styles from './ModalApproveWorker.module.scss';
import { Title } from 'components/Title';
import { Button } from 'ui/Button';
import { ReactComponent as IconCancel } from './img/iconCancel.svg';
import { ReactComponent as IconDone } from './img/iconDone.svg';

export const ModalApproveWorker = ({
  open,
  setOpen,
  approveWorker,
  id,
}: {
  open: boolean;
  setOpen: (e: boolean) => void;
  approveWorker?: (id: number) => void;
  id: number | null;
}) => {
  if (!id) {
    return null;
  }
  return (
    <Modal open={open} setOpen={setOpen}>
      <div className={styles.root}>
        <Title className={styles.root_title} title='Внимание!' />
        <p className={styles.root_message}>
          Исполнитель выполнял заказы для этого заказчика 3 месяца подряд. Это может
          повышать риск подмены трудовых отношений.
        </p>
        <p className={styles.root_message}>Продолжить назначение?</p>
        <div className={styles.root_btn}>
          <Button
            onClick={() => setOpen(false)}
            theme='outline'
            className={styles.root_btn_cancel}
            size='L'>
            <IconCancel />
          </Button>
          <Button
            onClick={() => approveWorker?.(id)}
            className={styles.root_btn_exit}
            theme='filed'
            size='L'>
            <div>
              Продолжить
              <IconDone />
            </div>
          </Button>
        </div>
      </div>
    </Modal>
  );
};
